/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Card, Button, Modal, Form } from 'react-bootstrap';
import { useTheme } from '../../../../providers/theme';

import * as S from './styles';

export interface IAcknowledgementModal {
  showModal?: boolean;
  modalTitle?: string;
  ackTitle?: string;
  buttonTitle?: string;
  data?: {
    label?: string;
    value?: string;
  };
  onDeny?(): void;
  onAcknowledgement?(value: any): void;
}

export const AcknowledgementModal = (props: IAcknowledgementModal) => {
  const {
    showModal,
    modalTitle,
    ackTitle,
    buttonTitle,
    data,
    onDeny,
    onAcknowledgement,
  } = props;
  const [show, setShow] = useState(showModal);
  const [acknowledgementId, setAcknowledgementId] = useState({});

  const theme = useTheme();

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };

  const _onFormSubmit = async (event: any) => {
    console.log(`onFormSubmit`, acknowledgementId);
    let _temp = [];
    for (const [key, value] of Object.entries(acknowledgementId)) {
      if (value === true) {
        _temp.push(key);
      }
    }
    if (event) {
      event.preventDefault();
      if (onAcknowledgement) {
        onAcknowledgement(_temp);
      }
      // 👇️ clear all input values in the form
      event.target.reset();
    }
  };

  const onAcknowledgementChange = (event: any) => {
    let tempObj = acknowledgementId;
    let tempSelection = {
      ...tempObj,
      [event.target.value]: event?.target?.checked,
    };
    setAcknowledgementId(tempSelection);
    console.log(`acknowledge change`, tempSelection);
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      scrollable={true}
      size={'lg'}
    >
      <Modal.Header className="border-0">
        <h4>{modalTitle}</h4>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Body>
            <>
              <Form onSubmit={_onFormSubmit}>
                <Form.Group controlId="IntendedPurpose">
                  <S.FormLabel color={theme?.colors?.primary}>
                    {ackTitle}
                    <sup style={{ color: 'red' }}>*</sup>
                  </S.FormLabel>
                  {Array.isArray(data) &&
                    data?.map((item: string, i: number) => {
                      return (
                        <Form.Check
                          required={
                            acknowledgementId &&
                            !Object?.values(acknowledgementId)?.includes(true)
                          }
                          key={`${item?.value}-${i}`}
                          label={item?.label}
                          className="formcheck mt-2 mb-1"
                          // ref={intendedPurposeRef}
                          name="intendedPurpose"
                          id={item?.value}
                          value={item?.value}
                          defaultChecked={
                            acknowledgementId && acknowledgementId[item?.value]
                          }
                          onChange={onAcknowledgementChange}
                        />
                      );
                    })}
                </Form.Group>
                <Button
                  type="submit"
                  className="text-white me-3"
                  size="sm"
                  variant="secondary"
                >
                  {buttonTitle}
                </Button>
              </Form>
            </>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

AcknowledgementModal.defaultProps = {
  ackTitle: 'Select the payout received and acknowledge',
  buttonTitle: 'Submit',
};
